export default __webpack_public_path__ + "static/media/whiskey.7650f3f2.jpg";